function stringToUuid(str) {
    if (typeof str === 'string' && str.length) {
        var string = str === null || str === void 0 ? void 0 : str.split('-').join('');
        return (string.substring(0, 8) +
            '-' +
            string.substring(8, 12) +
            '-' +
            string.substring(12, 16) +
            '-' +
            string.substring(16, 20) +
            '-' +
            string.substring(20));
    }
    return null;
}
export default stringToUuid;
//# sourceMappingURL=stringToUuid.js.map